
import React from "react";

import {
    LANG_BG,
} from './constants';

// Converts fahrenheit to celsius
export function fahToCelsius(fahrenheit: number) {
    if (fahrenheit === null) {
        return null;
    }

    return (fahrenheit - 32) * 5 / 9;
}

// Converts mph to m/s
export function mphToMs(mph: number) {
    if (mph === null) {
        return null;
    }

    return mph * 0.44704;
}

// Converts mph to km/h
export function mphToKmh(mph: number) {
    if (mph === null) {
        return null;
    }

    return mph * 1.60934;
}

// Converts inHg to hPa
export function inHgToHpa(inHg: number) {
    if (inHg === null) {
        return null;
    }

    return inHg * 33.86389;
}

// Converts inches to mm
export function inchesToMm(inches: number) {
    if (inches === null) {
        return null;
    }

    return inches * 25.4;
}

// Converts degrees to cardinal points
export function degToCardinal(deg: number) {
    if (deg === null) {
        return "";
    }

    // Create an array of cardinal points
    const arr = ["N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE", "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW"];
    // Divide the degree by 22.5 and add 0.5 to get the index of the array
    const val = Math.floor(deg / 22.5 + 0.5);
    // Return the cardinal point from the array using the modulus operator
    return arr[val % 16];
}

// Converts degrees to simplified cardinal points
export function degToSimpleCardinal(deg: number, lang: string) {
    if (deg === null) {
        return "";
    }

    // Create an array of simplified cardinal points
    const arrEn = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"];
    const arrBg = ["С", "СИ", "И", "ЮИ", "Ю", "ЮЗ", "З", "СЗ"]; 

    // Divide the degree by 45 and add 0.5 to get the index of the array
    const val = Math.floor(deg / 45 + 0.5);

    // Return the cardinal point from the array using the modulus operator
    if (lang === LANG_BG) {
        return arrBg[val % 8];
    } else {
        return arrEn[val % 8];
    }
}


export function formatBgTimeIfNeeded(dateTime: Date, lang: string): string {
    if (dateTime === null) {
        return "";
    }

    if (typeof dateTime === 'string') {
        dateTime = new Date(dateTime);
    }

    if (isNaN(dateTime.getTime())) {
        console.warn("Invalid date format: " + dateTime);
        return ""; // Or return a different default value
    }

    if (lang === LANG_BG) {
        return dateTime.toLocaleTimeString('bg-BG', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: false, // Use 24-hour format as common in Bulgarian locale
        });
    } else {
        return dateTime.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true, 
        });
    }
}


export function formatValueUnit(value: string | number | null, unit: string, decimalsForNumber = -1) {

    if (value !== null) {
        if (typeof value === 'number') {
            if (decimalsForNumber <= 0) {
                value = value.toFixed(0);
            }
            else {
                const formatted = value.toFixed(decimalsForNumber);

                if (formatted === "0") {
                    value = formatted;
                }
                else {
                    //value = formatted.replace(/0+$/, "").replace(/\.$/, "");

                    // Round the number to one decimal place
                    const rounded = Math.round(value * 10) / 10;
                    // Convert to string and use a regular expression to format
                    value = rounded.toString().replace(/\.0$/, '');
                }
            }
        }
    }

    return React.createElement(
        "span",
        null,
        React.createElement("span", { style: { fontWeight: "bold" } }, value),
        React.createElement("span", { style: { fontWeight: "normal" } }, unit)
    );
}

// Formats a number to a specified number of decimal places, removing trailing zeros.
export function toFixedExt(value: number, decimals = 1) {
    const formattedValue = value.toFixed(decimals);
    return formattedValue.replace(/0+$/, "").replace(/\.$/, "");
}